<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import { apiClient } from "@/client";

const props = defineProps<{ code: string }>();

const route = useRoute();
const router = useRouter();

const starting = ref(false);
const error = ref("");
const campaign = ref<string | null>(null);
const logoUrl = ref<string | null>(null);

async function start() {
	if (starting.value) return;
	starting.value = true;
	error.value = "";
	try {
		const res = await apiClient.JSONPost<{
			token: string;
			campaign: string;
			logo_url: string | null;
		}>("/api/rmo/mosquito-check/campaign", { code: props.code });
		campaign.value = res.campaign;
		logoUrl.value = res.logo_url;
		router.push(`/mosquito-check/${res.token}`);
	} catch (e: any) {
		error.value =
			e?.response?.status === 404
				? "This link isn't active anymore. Contact your mosquito district for a new one."
				: e?.message || "Something went wrong. Please try again.";
		starting.value = false;
	}
}
</script>

<template>
	<div class="campaign-shell d-flex flex-column">
		<div
			class="campaign-content flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center px-4"
		>
			<img
				v-if="logoUrl"
				:src="logoUrl"
				alt="District logo"
				class="campaign-logo mb-4"
			/>
			<h1 class="campaign-title mb-3">Mosquito Check</h1>
			<p class="campaign-body mb-0">
				Take a quick, guided walk around your home to find and fix mosquito
				breeding sources. Takes about 5 minutes.
			</p>
			<p v-if="campaign" class="campaign-tag mt-3 mb-0">
				{{ campaign }}
			</p>
		</div>
		<div class="campaign-footer px-4 pb-4">
			<div v-if="error" class="alert alert-danger mb-3">{{ error }}</div>
			<button
				class="btn btn-primary campaign-start"
				:disabled="starting"
				@click="start"
			>
				{{ starting ? "Starting…" : "Start" }}
			</button>
		</div>
	</div>
</template>

<style scoped>
.campaign-shell {
	height: 100dvh;
	max-width: 640px;
	margin: 0 auto;
}
.campaign-logo {
	max-height: 120px;
	width: auto;
}
.campaign-title {
	font-size: 2rem;
}
.campaign-body {
	font-size: 1.25rem;
	line-height: 1.5;
}
.campaign-tag {
	font-size: 0.9rem;
	color: var(--bs-secondary);
}
.campaign-start {
	width: 100%;
	font-size: 1.25rem;
	padding: 0.75rem 1rem;
}
</style>
